<script setup lang="ts">
import type { Ref } from "vue";
import { deviceTypeDeclinationMap } from "~/constants/deviceFilters.config";
import type { Option } from "~/core/models/filters";

const { t } = useI18n();

const props = defineProps<{
  modelValue: string[];
  types: string[];
}>();
const emit = defineEmits(["update:modelValue"]);

const loading: Ref<boolean> = ref(false);

const selectedItem = computed({
  get() {
    return props.modelValue ?? [];
  },
  set(selected?: string[]) {
    // Note: we are using destructuring assignment syntax here.
    emit("update:modelValue", selected);
  },
});

const declinations = computed((): Option[] => {
  if ((props.types?.length ?? 0) === 0) {
    return [];
  } else {
    let options: Option[] = [];
    for (const type of props.types) {
      const deviceTypeDeclination = deviceTypeDeclinationMap[type];
      if (deviceTypeDeclination) {
        options = options.concat(
          deviceTypeDeclination.deviceDeclinations.map(
            (declination: string): Option => {
              return {
                label: declination,
                value: declination,
              };
            },
          ),
        );
      }
    }
    return options;
  }
});
</script>

<template>
  <filter-selectable-list
    v-model="selectedItem"
    :data="declinations"
    :is-loading="loading"
    :empty-text="t('logs.filters.devices.model.empty')"
    :header="t('device.model')"
    prop="label"
    item-prop="value"
  />
</template>
